import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import {
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation,
  PORTAL_PREFIX,
  PAGE_PORTAL_COMPANY
} from "@kivunova/kivufrontendcommon";

const NoEmployeeDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {t("employee-not-found-title", "Employee Not Found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "employee-not-found-description",
          "The employee you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        variant="contained"
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() =>
          navigate(
            localizedPath(
              `/${PORTAL_PREFIX}/${PAGE_PORTAL_COMPANY}`,
              language,
              defaultLang
            )
          )
        }
      >
        {t("employee-back-to-list", "Back to Employee List")}
      </Button>
    </Box>
  );
};

export default NoEmployeeDetailFound;
